import React, { useEffect, useState } from "react";
import { Button, Dialog } from "@mui/material";
import CheckBoxCustom from '../checkbox';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from "../../constants/theme";

const TableSettingDialog = ({ 
  data = {}, 
  tableHeadings = {},
  changeTableSetting, 
  openSettings = false, 
  toggleSetting }) => {

  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [values, setValues] = useState({})
  useEffect(() => setValues(data), [data, openSettings])

  const onCheckOption = (key, value) => setValues({...values, [key]: value})

  const onCancel = (e, reason) => {
    if (reason && reason === "backdropClick") return;
    toggleSetting(false);
  };

  const onSubmit = () => {
    changeTableSetting(values)
    toggleSetting(false);
  };

  return (
    <Dialog fullScreen={fullScreen ?? false} open={openSettings} onClose={onCancel}>
      <div className="dialog-header">
        <div className="title ms-4">Хүснэгтийн тохиргоо</div>
        <button className="fab-btn" onClick={() => toggleSetting(false)}>
          <img alt="close" src="/images/close.svg" height={11} />
        </button>
      </div>
      <div className="table-setting-dialog dialog-body bg-white px-0 pb-0">
        <div className="dialog-sub-title mt-2">
          Баганын мэдээлэл
        </div>
        {
          Object.entries(values).map(([key, value]) =>(
            <div key={`settings-${key}`} className="setting-dialog-item dialog-item-border">
              <div className="title ps-5">{tableHeadings[key]}</div>
              <CheckBoxCustom value={value} handleChange={(e) => {
                onCheckOption(key, e.target.checked)
              }} />
            </div>
          ))
        }
      </div>
      <div className="dialog-footer">
        <Button
          onClick={onCancel}
          className="btn-bordered btn-bordered-grey mx-3"
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Цуцлах</span>
        </Button>
        <Button
          onClick={onSubmit}
          className="bg-primary btn-bordered"
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Хадгалах</span>
        </Button>
      </div>
    </Dialog>
  );
};

export default TableSettingDialog;
